/* tslint:disable:no-trailing-whitespace */
import { Component, ElementRef, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core'
import { InlineEditCellNewDirective } from '../inline-edit-cell-new'
import { FormControl } from '@angular/forms'
import { CatalogueEntry } from '@dot-it/jml-lib'

@Component({
  selector: 'jml-lib-dropdown-cell-new',
  templateUrl: './dropdown-cell.component.html',
  styleUrls: ['./dropdown-cell.component.scss']
})
/**
 * we expect value to be of an Object which at least has an id as a field
 */
export class DropdownCellComponent extends InlineEditCellNewDirective implements OnChanges {
  @Input() tableReference?: ElementRef
  @Input() options: CatalogueEntry[]
  @Input() header = ''
  @Input() showLabel = true
  @Input() showIcon = false
  @Input() showTooltip = false

  override newValue: FormControl<CatalogueEntry>
  selectedEntry: CatalogueEntry | undefined

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value || changes.options || changes.update) {
      this.initializeValue()
    }
  }

  initializeValue() {
    const selected = !!this.value ? this.options.find((option) => option.id === this.value.id) : undefined
    this.selectedEntry = selected
    this.newValue = new FormControl(selected)
  }

  triggerEdit() {
    // this is for cases where we already entered the edit mode, performed a change (in the drop down) and after sending the complete-event something went wrong:
    // we leave the edit mode, but when entering the edit mode, we need to re-initialize the original value, since the previously triggered change
    // could not become effective
    this.initializeValue()

    // TODO why is the timeout here?
    setTimeout(() => {
      this.isEdited = true
    }, 10)

    // Todo: Does not work. No abort when scrolling. Same for the old drop down cell.
    if (this.tableReference) {
      this.tableReference.nativeElement
        .querySelector('div.p-datatable-scrollable-body')
        ?.addEventListener('scroll', (ev: Event) => this.abortCellEdit(), { passive: true, once: true })
    }
  }

  save() {
    this.isEdited = false
    this.completeCellEdit.emit({ value: this.selectedEntry })
  }

  override abortCellEdit() {
    this.isEdited = false
  }
}
